module.exports = __webpack_public_path__ + "img/floor_f16_01.4e59a23d.png";